export const CHART_CARD_SX = {
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  minWidth: 0,
  minHeight: 232,
  overflow: 'visible',
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
};
